// title  标题
// tabbar: true 底部导航栏展示
// unpull: true 禁用下拉刷新
// unback: true, 不展示返回顶部按钮
// noheader: true 没有顶部
export default [
  {
    path: "invite/detail",
    name: "invite.detail",
    meta: {
      title: "邀请有奖详情页",
      unpull: true,
      noheader: true,
    },
    component: () => import("./InvitationDetails.vue"),
  },
  {
    path: "invite/register",
    name: "invite.register",
    meta: {
      title: "邀请注册",
      unpull: true,
      noheader: true,
    },
    component: () => import("./InvitationRegister.vue"),
  },
];
